import { FormGroup } from "@angular/forms";

export function markAllAsDirty(form: FormGroup) {
  Object.values(form.controls).forEach(control => {
    if (control && control.value) {
      control.markAsDirty();
    }
  });
}